import { useTranslation } from 'react-i18next';
import { GoogleLoginButton } from 'react-social-login-buttons';
import { getAuthorisationURLWithQueryParamsAndSetState } from 'supertokens-auth-react/recipe/thirdparty';

import { isSuperTokensError } from 'src/Components/Auth/ThirdPartySignInHandler/ThirdPartySignInHandler.component';

import styles from './GoogleSignInButton.module.scss';

const GoogleSignInButton = ({ compact }: { compact: boolean }) => {
  const { t } = useTranslation();
  const handleGoogleLoginClick = async () => {
    try {
      const authUrl = await getAuthorisationURLWithQueryParamsAndSetState({
        thirdPartyId: 'google',
        frontendRedirectURI: `${import.meta.env.VITE_PUBLIC_URL}/auth/callback`,
      });

      window.location.assign(authUrl);
    } catch (err: unknown) {
      if (isSuperTokensError(err)) {
        window.alert(err.message);
      } else {
        window.alert('Oops! Something went wrong.');
      }
    }
  };

  return (
    <GoogleLoginButton
      onClick={handleGoogleLoginClick}
      className={compact ? styles.compactButton : undefined}
    >
      {!compact && (
        <span className={styles.label}>{t('auth.connectWithGoogle', 'Continuer avec Google')}</span>
      )}
    </GoogleLoginButton>
  );
};

export default GoogleSignInButton;
